export const formatarValorParaReais = (valor: number) => {
  const result = valor / 100;
  return result.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};
